import { takeEvery } from 'redux-saga/effects';

import * as signInActions from 'store/modules/auth/signIn';
import { signIn } from './utils';

export default function* listenSignIn() {
  yield takeEvery(signInActions.signIn.toString(), signIn);
}
